<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      Edit Member Diary
    </div>
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberData/listMemberDiary?id=' + id_lead_member + '&id_lead=' + id_lead + '&date=' + member_diary_date)" class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
            <!-- <a @click="openPage('/memberData/detail?id=' + id_lead_member + '&id_lead=' + id_lead)" class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a> -->
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-20 pt-0">
        <form @submit.prevent="submitMemberDiary">
          <hr class="short-line left">
          <div class="row mb-30">
            <div class="col-lg-6">
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <div>Member Diary Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.excercise_name" name="member_diary_name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('member_diary_name') }}</span>
                </b-col>
              </b-row> -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Schedule Date</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr :config="exportConfig" class="font-13 border-bottom" v-model="addData.schedule_date" name="schedule_date"></flat-pickr>
                  <span class="error">{{ errors.first('schedule_date') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Member Diary Category</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="changeDiaryCategory" v-validate="'required'" name="member_category" v-model="member_category" class="form-control border-bottom">
                    <option :value="null" selected>Please select</option>
                    <option v-for="(data2, index) in listCategory" :key="index" :value="data2.id">
                      {{data2.name}}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('member_category') }}</span>
                </b-col>
              </b-row>
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <div>Member Diary Subcategory</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="changeDiarySubcategory" v-validate="'required'" name="member_subcategory" v-model="member_subcategory" class="form-control border-bottom">
                    <option :value="null" selected>Please select</option>
                    <option v-for="(data, index) in listSubcategory" :key="index" :value="data.id">
                      {{data.name}}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('member_subcategory') }}</span>
                </b-col>
              </b-row> -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Member Diary Activity</div>
                </b-col>
                <b-col sm="4">
                  <b-form-input
                      :disabled="addData.member_pt_diary_activity_id != null || member_category == 1 || member_category == 148"
                      v-on:input="onChangeInputActivity($event, 'input_member_pt_diary_activity_id')"
                      class="form-control border-bottom"
                      name="member_pt_diary_activity_id"
                      type="text"
                      v-model="activityInputValue"
                      placeholder="Exercise Name">
                  </b-form-input>
                </b-col>
                <b-col sm="4">
                  <b-form-select
                  :disabled="disableSelectActivity"
                  v-on:input="onChangeSelectActivity($event, 'select_member_pt_diary_activity_id')"
                  name="member_pt_diary_activity_id" v-model="addData.member_pt_diary_activity_id" class="form-control border-bottom">
                    <option :value="null" selected>Please select</option>
                    <option v-for="(itemDiary, index) in dataDiaryActivity" :key="index" :value="itemDiary.id">{{itemDiary.excercise_name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('member_pt_diary_activity_id') }}</span>
                </b-col>
                <b-col sm="1" style="padding: none">
                    <div v-if="!disableSelectActivity" v-on:click="reset(addData.member_pt_diary_activity_id, 'activity')" style="display: block;margin-left: -14px;margin-top: 5px;color: #f36262;cursor: pointer">
                      <i class="fas fa-trash"></i>
                    </div>
                  </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Personal Trainer</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select v-validate="'required'" name="personal_trainer" v-model="addData.personal_trainer_id" class="form-control border-bottom" :disabled="true">
                    <option :value="null" selected>Please select</option>
                    <option v-for="(item, index) in dataPT" :key="index" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('personal_trainer') }}</span>
                </b-col>
              </b-row>
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <label>Time</label>
                </b-col>
                <b-col sm="9">
                  <div class="select-time">
                    <flat-pickr :config="timeConfig" v-model="addData.time" name="time" class="form-control border-bottom"></flat-pickr>
                  </div>
                </b-col>
              </b-row> -->
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <label>Rest Time</label>
                </b-col>
                <b-col sm="9">
                  <div class="select-time">
                    <flat-pickr :config="timeConfig" v-model="addData.rest_time" name="rest_time" class="form-control border-bottom"></flat-pickr>
                  </div>
                </b-col>
              </b-row> -->
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Sets</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.sets" name="sets" type="text"></b-form-input>
                  <span class="error">{{ errors.first('sets') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Reps</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.reps" name="reps" type="text"></b-form-input>
                  <span class="error">{{ errors.first('reps') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Weight</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.weight" name="weight" type="text"></b-form-input>
                  <span class="error">{{ errors.first('weight') }}</span>
                </b-col>
              </b-row>
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <div>One RM</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.one_rm" name="one_rm" v-validate="'numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('one_rm') }}</span>
                </b-col>
              </b-row> -->
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <div>Dist</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.dist" name="dist" v-validate="'numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('dist') }}</span>
                </b-col>
              </b-row> -->
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <div>Intensity</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.intensity" name="intensity" v-validate="'numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('intensity') }}</span>
                </b-col>
              </b-row> -->
              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <div>Member</div>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" :options="optionsMember" class="border-bottom" name="member_id" v-model="addData.member_id"></model-select>
                  </div>
                  <span class="error">{{ errors.first('member_name') }}</span>
                </b-col>
              </b-row> -->
            </div>
            <div class="col-12">
              <div class="mb-5">Notes</div>
              <textarea class="form-control w-100" rows="3" v-model="addData.notes" name="notes" type="text"></textarea>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'addMemberDiary',
  components: {
    ModelSelect
  },
  data: function () {
    return {
      config: {},
      dataPT: [],
      member_diary_date: '',
      member_category: null,
      member_subcategory: null,
      disableSelectActivity: false,
      disableInputActivity: false,
      activityInputValue: null,
      dataDiaryActivity: [],
      listSubcategory: [],
      listCategory: [],
      id_lead_member: '',
      id_lead: '',
      exportConfig: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d F Y",
        // onChange: this.onChange
      },
      timeConfig: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        defaultDate: "00:00:00",
        static: true,
        time_24hr: true
      },
      addData: {
        schedule_date: moment(new Date()).format('YYYY-MM-DD'),
        member_pt_diary_activity_id: null,
        member_id: null,
        personal_trainer_id: null
      },
      getCategory: '',
      getSubcategory: '',
      optionsMember: [
        { value: null, text: 'Please select' }
      ]
    }
  },
  methods: {
    reset(data, type='') {
      if (type == 'activity') {
        console.log(data)
        axios.get("crm/v1/member_pt_diary_activity/delete/" + data).then(response => {
          console.log(response)
          this.fetchData()
        })
      }
    },
    onChangeInputActivity(data, id) {
      console.log(data)
      if (data != '') {
        this.disableSelectActivity =true
      } else {
         this.disableSelectActivity =false
      }
    },
    onChangeSelectActivity(data, id) {
      console.log(data)
    },
    changeDiaryCategory(event) {
      this.getDiaryActivity(event)
      console.log('test', event)
      axios.get('crm/v1/member_pt_diary_subcategory?category=' + event).then(response => {
        this.listSubcategory = response.data.data
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getDiaryActivity(category_id) {
      axios
        .get("crm/v1/member_pt_diary_activity?category_id=" + category_id)
        .then(response => {
          console.log(response)
          this.dataDiaryActivity = response.data.data.rows
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    changeDiarySubcategory(event) {
      // axios.get('crm/v1/member_pt_diary_activity?subcategory=' + event).then(response => {
      //   this.dataDiaryActivity = response.data.data.rows
      //   // console.log('test', response.data.data.rows)
      // }).catch(error => {
      //   console.log('error', error)
      // })
    },
    submitMemberDiary () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          if (this.activityInputValue != null) {
            this.addData.member_pt_diary_activity_id = this.activityInputValue
          }
          if (this.member_category != null) {
            this.addData.member_pt_diary_category_id = this.member_category
          }
          // this.addData.member_id = this.id_lead_member
          axios.put('crm/v1/member_pt_diary/' + this.$route.query.id_item, this.addData).then(response => {
            // console.log('test', response)
            this.$router.back()
            // this.$router.push('/memberData/detail?id=' + this.id_lead_member + '&id_lead=' + this.id_lead)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            console.log('error', error.response)
            // console.log('error', error.response.data.error)
            if (error.response.data) {
              this.$toast.success(error.response.data.error, 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            } else {
              this.$toast.success('Cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      // this.$router.push(event)
      this.$router.back()
    },
    fetchData() {
      // turn off autocomplete
      if(document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id")
        for (var i=0; inputElements[i]; i++) {
          if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete","off")
          }
        }
      }
      axios.get('fitness/v1/member/data_entry').then(response => {
        var dataMember = response.data.data.rows
        for (var i = 0; i < dataMember.length; i++) {
          let memberBranchId
          if(!dataMember[i].branch_id) {
            memberBranchId = '(FT-' + dataMember[i].id + ') ' + dataMember[i].first_name + ' ' + dataMember[i].last_name
          } else {
            memberBranchId = '(' + dataMember[i].branch.codename + '-' + dataMember[i].id + ') ' + dataMember[i].first_name + ' ' + dataMember[i].last_name
          }
          // var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: dataMember[i].id, text: dataMember[i].first_name + ' ' + dataMember[i].last_name})
          var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: dataMember[i].id, text: memberBranchId})
          this.optionsMember.push(dataComplete)
        }
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/personal_training').then(response => {
        this.dataPT = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/member_pt_diary_category').then(response => {
        this.listCategory = response.data.data
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/member_pt_diary/'+ this.$route.query.id_item).then(response => {
        this.addData = response.data.data
        this.member_category = response.data.data.member_pt_diary_category_id
        this.addData.member_pt_diary_activity_id = response.data.data.member_pt_diary_activity_id
        this.member_subcategory = response.data.data.member_pt_diary_subcategory_id
        if (response.data.data.member_pt_diary_category_id != null) {
          this.disableInputActivity = true
        }
        this.changeDiaryCategory(this.member_category)
        this.changeDiarySubcategory(this.member_subcategory)
        // console.log('test', response.data.data)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
    this.id_lead_member = this.$route.query.id
    this.id_lead = this.$route.query.id_lead
    this.member_diary_date = this.$route.query.date
  }
}
</script>

<style>
</style>
